export class ProgramaResponseModel {
  idSistema: number | undefined;
  codigoSistema: string | undefined;
  nombreSistema: string | undefined;

  constructor() {
    this.idSistema = 0;
    this.codigoSistema = "";
    this.nombreSistema = "";
  }
}
